<template>
  <div class="sticky top-0 z-40 ">
    <div class="w-full h-20 px-6 bg-white  flex items-center justify-between">

      <!-- left navbar -->
      <div class="flex">
        <div class="mr-10 ml-10">
          <!-- <img :src="HOPE_KIT_WORDMARK" alt="Hope Kit Wordmark" class="h-10 mr-4" /> -->
          <p class="font-semibold text-3xl text-primary">
            Hope&nbsp;Kit
            <img :src="hopekit_icon" alt="Hope Kit Icon" class="h-10 mr-4 inline -mt-1" />
          </p>
        </div>
      </div>

      <!-- right navbar -->
      <div class="flex items-center relative">
        <!-- <Bell class="mr-4 text-primary"></Bell> -->
        <BoringAvatar v-if="profilePic == ''" :size="40" :name="user.nickname" :variant="'beam'"
          :colors="['#92A1C6', '#146A7C', '#F0AB3D', '#C271B4', '#C20D90']" class="w-12 h-12 rounded-full shadow-lg"
          @click="dropDownOpen = !dropDownOpen" />
        <img v-else :src="profilePic" alt="profile picture" class="w-12 h-12 rounded-full shadow-lg"
          @click="dropDownOpen = !dropDownOpen" />
      </div>

    </div>

    <!-- dropdown menu -->
    <div class="absolute bg-gray-100 border border-t-0 shadow-xl text-gray-700 rounded-b-lg w-48 right-0 mr-6"
      :class="dropDownOpen ? '' : 'hidden'">
      <RouterLink :to="{ name: 'account' }" @click="dropDownOpen = false">
        <a href="#" class="block px-4 py-2 hover:bg-gray-200">Account</a>
      </RouterLink>
      <a v-if="canSudoToUser" href="#" class="block px-4 py-2 hover:bg-gray-200" @click="switchTo('user')">Switch to
        User</a>
      <a v-if="canSudoToClinician" href="#" class="block px-4 py-2 hover:bg-gray-200"
        @click="switchTo('clinician')">Switch to Clinician</a>
      <a v-if="canSudoToAdmin" href="#" class="block px-4 py-2 hover:bg-gray-200" @click="switchTo('admin')">Switch to
        Admin</a>
      <!-- <a href="#" class="block px-4 py-2 hover:bg-gray-200">Settings</a> -->
      <RouterLink :to="{ name: 'logout' }" @click="dropDownOpen = false">
        <a href="#" class="block px-4 py-2 hover:bg-gray-200">Logout</a>
      </RouterLink>


      <br>
    </div>
    <!-- dropdown menu end -->

  </div>
</template>

<script setup lang="ts">
import { ref, computed, reactive, onMounted } from 'vue'
import { useUserStore, type User } from '@/stores/user'
import { useAuthStore } from '@/stores/auth'
import BoringAvatar from 'vue-boring-avatars'
import hopekit_icon from '/svg/hopekit_icon_nws.svg'
// import { Bell } from 'lucide-vue-next'

// const store = useSidebarStore()
const userStore = useUserStore()
const dropDownOpen = ref(false)
const user = reactive<User>(userStore.current_user)
const canSudoToUser = ref(false)
const canSudoToClinician = ref(false)
const canSudoToAdmin = ref(false)

onMounted(async () => {
  await userStore.getCurrentUser()
  canSudoToUser.value = canSudoTo('user')
  canSudoToClinician.value = canSudoTo('clinician')
  canSudoToAdmin.value = canSudoTo('admin')
})

// const toggleSidebar = () => {
//   store.toggleSidebar()
// }

const canSudoTo = (role: string): boolean => {
  if (!user) return false
  return user.sudo == true && user.role !== role
}

const switchTo = (role: string) => {
  useAuthStore().sudo(role)
}

const profilePic = computed(() => userStore.profile_pic)
</script>
